import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import GroupMain from "Components/Groups/GroupMain";
// const GroupMain = React.lazy(() => import("Components/Groups/GroupMain"));

const Groups = () => {
  return (
    // <ContainerWrapper>
    <GroupMain />
    // </ContainerWrapper>
  );
};

export default Groups;
